import { render } from "./SmartMirrorProject.vue?vue&type=template&id=9f4cbf6e&scoped=true"
import script from "./SmartMirrorProject.vue?vue&type=script&lang=js"
export * from "./SmartMirrorProject.vue?vue&type=script&lang=js"

import "./SmartMirrorProject.vue?vue&type=style&index=0&id=9f4cbf6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f4cbf6e"]])

export default __exports__